import { atom } from "recoil";

const uiConfigAtom = atom({

    key:"uiConfig",
    default: null

});

export default uiConfigAtom;